export function GetPumpLiftingHeightTips(model) {
    if (model.pumpLiftingHeight.visible === true && model.pumpLiftingHeight.value !== null) {
        if (model.pumpFlow.value === null) {
            return [`${__('Lifting height')}: ${model.pumpLiftingHeight.value} ${model.pumpLiftingHeight.unit}`]
        } else {
            return [`${__('Lifting height')}: ${model.pumpLiftingHeight.value} ${model.pumpLiftingHeight.unit} ${(__('at'))} ${model.pumpFlow.value} ${model.pumpFlow.unit}`]
        }
    }
}